import React from 'react'
import {
  Platform,
  RefreshControl as RefreshControlNative,
  RefreshControlProps,
} from 'react-native'
import { RefreshControl as RefreshControlWeb } from 'react-native-web-refresh-control'

const RefreshControl = React.forwardRef(
  (props: RefreshControlProps, ref: React.Ref<any>) => {
    if (Platform.OS === 'web') {
      return <RefreshControlWeb ref={ref} {...props} />
    }
    return <RefreshControlNative ref={ref} {...props} />
  }
)

export default RefreshControl
